module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 135.20da7355.png";